import React from 'react';
import { IRateConfigurationData } from 'types/administration/pricing/underwriterProfileInterfaces/IRateConfiguration';
import { ViewerTemplate } from '../ViewerTemplate';
import { LabelValueViewer } from '../shared/LabelValueViewer';
import { RateViewer } from '../shared/RateViewer';

interface IRateConfigurationViewerProps {
  rateConfiguration: IRateConfigurationData;
}

export const RateConfigurationViewer: React.FC<IRateConfigurationViewerProps> = ({ rateConfiguration }) => (
  <ViewerTemplate
    viewerName={`Rate Configuration ${!!rateConfiguration.derivedFrom ? 'Derived' : ''}`}
    templateColumns={'1fr 4fr'}
  >
    <LabelValueViewer
      label={'Additional Minimum  '}
      value={String(rateConfiguration.additionalMinimum)}
      templateColumns={'1fr 2fr'}
    />
    {rateConfiguration.minimum !== undefined && (
      <LabelValueViewer label={'Minimum'} value={rateConfiguration.minimum} templateColumns={'1fr 2fr'} />
    )}
    {rateConfiguration.multiplier !== undefined && (
      <LabelValueViewer label={'Multiplier'} value={rateConfiguration.multiplier} templateColumns={'1fr 2fr'} />
    )}
    <RateViewer
      rate={rateConfiguration.baseCalculator}
      multiplier={rateConfiguration.multiplier}
      title={'Calculator'}
    />
    {rateConfiguration.excessCalculator && (
      <RateViewer
        rate={rateConfiguration.excessCalculator}
        multiplier={rateConfiguration.multiplier}
        title={'Excess Calculator'}
      />
    )}
  </ViewerTemplate>
);
